import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 日本入荷一覧：基本情報のリスト取得（日本入荷工場、日本入荷状態、支払状態、ユーザーリスト、仕入先リスト）
 */
export function initJpReceSearchList(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitJpReceSearchList, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 検索日本入荷一覧情報
 */
export function searchJpReceBasic(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceBasic, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 日本入荷一覧：日本入荷No.によると、日本入荷基本情報と明細情報の削除
 */
export function deleteJpReceBasicByNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteJpReceBasicByNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 日本入荷明細：基本情報のリスト取得（日本入荷状態、支払状態、ユーザーリスト、仕入先リスト）
 */
export function getJpReceInitList(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetJpReceInitList, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 日本入荷明細：基本情報のリスト取得（日本入荷状態、支払状態、ユーザーリスト、仕入先リスト）
 */
export function searchJpReceDetailByReceNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceDetailByReceNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 日本入荷運送選択画面：情報の検索
 */
export function searchJpReceTransSelect(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceTransSelect, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 運送選択画面：情報の検索
 */
export function getTransSelect(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetTransSelect, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 日本入荷明細：日本入荷No.によると、日本入荷基本情報と明細情報の更新
 */
export function updateJpReceDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateJpReceDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 日本入荷明細：日本入荷基本情報と明細情報の新規追加
 */
export function addJpReceDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddJpReceDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 日本入荷詳細画面（大連以外の工場）：注文製品選択情報の検索
 */
export function getOrderSelect(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetOrderSelect, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 日本入荷詳細画面（大連以外の工場）：注文製品選択情報⇒日本入荷詳細
 */
export function getOrderSelectedData(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetOrderSelectedData, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 再入荷申請確認画面：再入荷情報は注文情報に保存される
 */
export function saveReceAgainOrderInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SaveReceAgainOrderInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 再入荷申請確認画面：注文明細データの取得
 */
export function getOrderDetailForm(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetOrderDetailForm, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 日本入荷詳細画面（大連工場）：日本入荷No.によると、日本入荷基本情報と明細情報の検索
 */
export function getJpReceDetailJP(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetJpReceDetailJP, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

// ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 start↓
/**
 * 入荷異常画面：データ検索
*/
export function searchReceProdInfoByProdNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchReceProdInfoByProdNo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 入荷異常画面：データ更新
*/
export function updateReceNgInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateReceNgInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/07/01 Wjx 課題_数量·納期調整機能の追加 end↑

// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
/**
 * 入荷詳細画面選択情報の取得(配送単から)
 */
export function searchJpReceByDeliceryFile(data) {

  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchJpReceByDeliceryFile, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑
